var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.321 5.5H5.68A2.682 2.682 0 0 0 3 8.179v12.5a2.681 2.681 0 0 0 2.679 2.678h1.233l1.54 3.078a.892.892 0 0 0 1.24.376l6.045-3.454h9.584A2.681 2.681 0 0 0 28 20.68v-12.5A2.681 2.681 0 0 0 25.321 5.5zm-1.785 8.929H7.464a.893.893 0 0 1 0-1.786h16.072a.893.893 0 1 1 0 1.786zm0-3.572H7.464a.893.893 0 1 1 0-1.786h16.072a.893.893 0 0 1 0 1.786z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.eb6c5be2c67a174067243cf11afcd7fe.svg";
export { ForwardRef as ReactComponent };